import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-all-payment-link',
  templateUrl: './view-all-payment-link.page.html',
  styleUrls: ['./view-all-payment-link.page.scss'],
})
export class ViewAllPaymentLinkPage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
